<template>
	<div>
		<div class="each-question" v-for="question in questions" :key="question.id">
			<div class="row question align-items-start">
				<div class="col-12 col-md-6 text-left mb-3 mb-md-0 statement">
					<p>{{ question.question }}</p>
				</div>
				<div class="col-12 col-md-6 answer d-flex flex-column">
					<div class="row">
						<div class="col-6 pr-0">
							<button 
								v-bind:class="{ active: getAnswerById(question.id).answer == 1, inactive: getAnswerById(question.id).answer == 0 }" 
								@click="answerQuestion($event, question.id, 1, question.answer, question.question)" 
								type="button" 
								value="1" 
								class="js-button-selected-answer" 
								:data-id="question.id"
							>{{ answerYesLabel }}</button>
							<div class="icon-answer" v-if="getAnswerById(question.id).answer == 1">
								<div v-if="getAnswerById(question.id).result != null">
									<img v-if="getAnswerById(question.id).isCorrect" class="icon-correct" src="/images/icon_correct.png">
									<img v-if=" ! getAnswerById(question.id).isCorrect" class="icon-incorrect" src="/images/icon_incorrect.png">
								</div>
							</div>
						</div>
						<div class="col-6 pl-0">
							<button 
								v-bind:class="{ active: getAnswerById(question.id).answer == 0, inactive: getAnswerById(question.id).answer == 1}" 
								@click="answerQuestion($event, question.id, 0, question.answer, question.question)" 
								type="button" 
								value="0" 
								class="js-button-selected-answer border-left-none" 
								:data-id="question.id"
							>{{ answerNoLabel }}</button>
							<div class="icon-answer" v-if="getAnswerById(question.id).answer == 0">
								<div v-if="getAnswerById(question.id).result != null">
									<img v-if="getAnswerById(question.id).isCorrect" class="icon-correct" src="/images/icon_correct.png">
									<img v-if=" ! getAnswerById(question.id).isCorrect" class="icon-incorrect" src="/images/icon_incorrect.png">
								</div>
							</div>
						</div>
					</div>
					<p class="mt-2 description" v-if="getAnswerById(question.id).result != null" v-html="question.description"></p>
					<input type="hidden" class="js-correct-answer" name="answer" :value="question.answer">
				</div>
				
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			'questions': Array,
			'answer-yes-label': String,
			'answer-no-label': String,
			'save-result': {
				type: Boolean,
				default: false,
			},
		},
		mounted() {
			// // for remember user answer of quiz
			let data = sessionStorage.getItem('questions.answered');
			let session_answers = JSON.parse(data);
			
			if (Array.isArray(session_answers)) {
				this.answers = session_answers;
			}
		},
		data() {
			return {
				answers: [],
			}
		},
		computed: {
			
		},
		methods: {
			answerQuestion(e, id, answer, result, question){
				e.preventDefault();
				
				if (this.isAnswerInObject(id)) {
					return;
				}
				
				let is_correct = this.isAnswerCorrect(result, answer);
				let answerData = {
					id: id,
					question: question,
					answer: answer,
					result: result,
					isCorrect: is_correct,
				};
				this.answers.push(answerData);
				
				let data = sessionStorage.getItem('questions.answered');
				let session_answers = JSON.parse(data);

				if ( ! Array.isArray(session_answers)) {
					session_answers = [];
				}
				
				if (this.isAnswerInObject(id, session_answers)) {
					return;
				}
				
				session_answers.push(answerData);
				sessionStorage.setItem('questions.answered', JSON.stringify(session_answers));

				let classicDataLayer = {
					'event': 'question',
					'action': 'answered',
					'id': id,
					'answer': answer,
					'result': result,
					'isCorrect': is_correct,
				};
				
				let providerDataLayer = {
					'category': 'HPquestion',
					'label': `${id} - ${answer ? 'yes' : 'no'}`,
				};

				if(this.saveResult) {
					classicDataLayer = {...classicDataLayer, ...providerDataLayer};
				}

				if(typeof dataLayer !== 'undefined') {
					dataLayer.push(classicDataLayer);
				}
				
				let associationReference = sessionStorage.getItem('association.reference');
				this.saveQuizResult(session_answers, JSON.parse(associationReference));
			},
			isAnswerCorrect(result, answer){
				return (result == answer) ? true : false ;
			},
			getAnswerById(id, data){
				data = data || this.answers;
				
				for (var i = 0; i < data.length; i++) {
					if (data[i].id == id) {
						return data[i];
					}
				}
				
				return {};
			},
			isAnswerInObject(id, data){
				data = data || this.answers;
				
				let answer = this.getAnswerById(id, data);
				
				return (answer.id == id) ? true : false ;
			
			},
			saveQuizResult(quizResult, associationReference){
				axios.post('/api/save-quiz-result', {
						data: quizResult,
						association_reference: associationReference,
					})
					.then((response) => {
						// console.log(response);
					})
					.catch((error) => {
						console.log(error);
					});
			},
		}
	}


</script>



// WEBPACK FOOTER //
// resources/assets/js/components/FraudQuizComponent.vue